module.exports = __webpack_public_path__ + "img/logo_black.8a31b1f1.jpg";